import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';

// Import Selectors
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import SAMLForm from '../../../Admin/components/SAMLForm';

class SAMLPage extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  render() {
    const { organization } = this.props;
    const isDemo = organization && organization.is_demo;
    if (isDemo) {
      return (
        <div>
          <Helmet title="SAML Settings | Organization Setup" />
          <div className="container">
            <div className="alert alert-danger">You cannot change SAML settings this organization.</div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <Helmet title="SAML Settings | Organization Setup" />
        <div className="container">
          <SAMLForm
            show
            modal={false}
            organization={organization}
          />
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

SAMLPage.propTypes = {
  organization: PropTypes.shape({
    is_demo: PropTypes.bool,
    type: PropTypes.string,
  }).isRequired,
};

SAMLPage.defaultProps = {
};

export default connect(mapStateToProps)(SAMLPage);
